export default __webpack_public_path__ + "i18n/fr.b6a928af25fbc93b9382f7576ee61cd6.json";